import { Component, OnInit, Input,Output ,EventEmitter } from '@angular/core';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { GlobalService } from '../../../global.service';
@Component({
  selector: 'app-security-questions-password',
  templateUrl: './security-questions-password.component.html',
  styleUrls: ['./security-questions-password.component.sass']
})
export class SecurityQuestionsPasswordComponent implements OnInit {
  @Input() forgotPasawordStatus;
  @Input() challengeQuestions;
  @Input() subscriber;
  @Output() updateView = new EventEmitter<number>();
  @Output() updatePass = new EventEmitter<string>();
  @Output() updateToken = new EventEmitter<string>();
  public anwser0='';
  public anwser1='';
  public newpassword='';
  public token='';
  constructor(private services:Service,private global:GlobalService,private loadingScreenService:LoadingScreenService) { }

  ngOnInit() {
  }
  getpasswordrecovery() {
    if (this.anwser0.length > 0 && this.anwser1.length > 0) {
        // $rootScope.showLoader = true;
       this.challengeQuestions[0].response = this.anwser0;
       this.challengeQuestions[1].response = this.anwser1;
        this.services.getpasswordrecovery(this.subscriber, JSON.stringify(this.challengeQuestions)).subscribe(data =>{
          this.loadingScreenService.stopLoading();
          if(data.hasError ==false){
            this.forgotPasawordStatus=2;
                this.newpassword = data.newpassword;
                this.token = data.token;
                // changeView('register', 'step4');
                this.updatePass.emit(this.newpassword);
                this.updateToken.emit(this.token);
                this.updateView.emit(3);
          }
          else{
            this.global.notif(data.errorDesc);
          }
        });
    }else{
      this.global.notif('Por favor, complete los campos para continuar.');
       }
  }
}
